import axios from 'axios';
import CONFIG from './config';
import { getAccessToken } from './storage.service';

const request = (url: string, params?: any) => {
  if (!params) {
    params = {};
  }
  url.split('/')[0];
  const uri = CONFIG.http[url.split('/')[1]] + url;
  axios.interceptors.response.use(
    (response: any) => response,
    (error: any) => {
      // Do something with response error
      if (error && error.response && error.response.status === 401) {
        localStorage.removeItem('auth');
      }

      let errorMessage =
        (error &&
          error.response &&
          error.response.data &&
          error.response.data.message) ||
        error;
      errorMessage = errorMessage || error.message;
      console.log(`Promise Error---`, error);

      // return Promise.reject(errorMessage);
      // message.error(errorMessage);
      const e = new Error(errorMessage);

      throw e;
    }
  );

  const headers = {
    'Content-type': 'application/json',
    Authorization: `Bearer ${getAccessToken()}`,
    ...params.headers
  };
  const method = params.method || 'GET';
  const others: any = {};
  if (params.responseType) {
    others.responseType = params.responseType;
  }

  return axios({
    method,
    url: uri,
    data:
      method === 'PATCH' ||
      method === 'POST' ||
      method === 'PUT' ||
      method === 'DELETE'
        ? params.body
        : undefined,
    params: method === 'GET' ? params.body : undefined,
    headers,
    ...others
  }).then((response: any) => {
    if (response.status >= 200 && response.status < 300) {
      return response;
    }

    const error = new Error(response);

    throw error;
  });
};

export default request;
